import pad2 from "~/helpers/pad2";

export const REGEX_PATTERNS = {
  // Negated classes must escape `[]()` etc. so `.source` works as HTML `pattern` (compiled with RegExp `v`).
  EMAIL:
    /^(([^<>\(\)\[\]\\.,;:\s@"]+(\.[^<>\(\)\[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,}))$/,
  PHONE: {
    AREA: /^([2-9][0-8][0-9])$/,
    EXCHANGE: /^([2-9][0-9]{2})$/,
    REPEATING: /^(\d)\1{9}$/,
  },
  SSN: /^\(?\d{3}\)?[- ]?\d{2}[- ]?\d{4}$/,
  NAME: /^[a-zA-Z\s\.\'’-]+$/,
};

export const MONTHS = [
  { value: "01", label: "01" },
  { value: "02", label: "02" },
  { value: "03", label: "03" },
  { value: "04", label: "04" },
  { value: "05", label: "05" },
  { value: "06", label: "06" },
  { value: "07", label: "07" },
  { value: "08", label: "08" },
  { value: "09", label: "09" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
];

export const DAYS = (() => {
  return Array.from(Array(31)).map((_, index) => {
    const day = pad2(index + 1);
    return {
      value: day,
      label: day,
    };
  });
})();

export const MINIMUM_AGE = 18;
export const OLDEST_YEAR = 1900;

export const YEARS = (() => {
  const currentYear = new Date().getUTCFullYear() - MINIMUM_AGE;

  return Array.from(Array(currentYear - (OLDEST_YEAR - 1))).map((_, index) => {
    const year = (currentYear - index).toString();
    return {
      value: year,
      label: year,
    };
  });
})();
